import React, { Component  } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderTitle } from '../../../components/molecues';

class NativeAppNotice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: 11,
            src: null,
        }
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    onClickHome = () => {
        this.props.history.replace('/');
    }
    render() {
        const propsHeader = {
            current: this.state.current,
            onClickHome: this.onClickHome,
        };
        return(
            <React.Fragment>
            <HeaderTitle {...propsHeader}></HeaderTitle>
            <Body>
                <OverViewRegion>
                    <Label>移行について</Label>
                    <TextBox>シャドプラスはWEBアプリからネイティブアプリへ移行いたします。ネイティブアプリではより快適な学習体験をお届けします。WEBアプリは今後提供を終了する予定です（終了日は別途ご案内いたします）。</TextBox>
                </OverViewRegion>
                <AppBatchRegion>
                    <Label>アプリのダウンロード</Label>
                    <p>iOS 版: <a href = "https://apps.apple.com/jp/app/%E3%82%B7%E3%83%A3%E3%83%89%E3%83%97%E3%83%A9%E3%82%B9/id6759359837">App Store</a></p>
                    <p>Android 版: <a href = "https://play.google.com/store/apps/details?id=jp.studyhacker.shadoplus">Google play</a></p>
                </AppBatchRegion>
                <StepRegion>
                    <Label>移行手順</Label>
                    <TextBox>移行は約1分で完了します。</TextBox>
                    <StepBox><StepNum>1</StepNum>上記ボタンからアプリをダウンロード</StepBox>
                    <TextBox>お使いの端末に合ったアプリストアへアクセスし、アプリをダウンロードしてください。</TextBox>
                    <StepBox><StepNum>2</StepNum>アプリを起動し「ログインして学習を始める」をタップ</StepBox>
                    <TextBox>「ログインして学習を始める」ボタンを押下し、以下ご入力ください。</TextBox>
                    <StepBox><StepNum>3</StepNum>現在のアカウント情報でログイン</StepBox>
                    <ul>
                        <li>現在Web版で利用しているメールアドレス</li>
                        <li>仮パスワード「shadoplus2604」</li>
                    </ul>
                    <TextBox>その後、メール認証、新しいパスワード設定を完了させると移行完了です。</TextBox>
                    <TextBox>「ログインして学習を始める」以外からですとご利用料金が別途発生してしまうためご注意ください。</TextBox>
                    <TextBox>ご利用中のメールアドレスがわからない場合はシャドプラス事務局へお問い合わせください。</TextBox>
                </StepRegion>
                <QaRegion>
                    <Label>よくあるご質問</Label>
                    <QaBox>
                        <QaTitle>Q. WEBアプリはいつまで使えますか？</QaTitle>
                        <TextBox>A. 終了日は追ってお知らせいたします。お早めの移行をお勧めいたします。</TextBox>
                    </QaBox>
                </QaRegion>
                <InquiryRegion>
                    <Label>お問い合わせ</Label>
                    <TextBox>ご不明点がございましたら、アプリ内またはWEBアプリ内のお問い合わせフォームよりご連絡ください。</TextBox>
                </InquiryRegion>
            </Body>
            </React.Fragment>
        );
    }
}

export { NativeAppNotice };

const Body = styled.div`
    padding: 0px 16px;
    font-size: 13px;
    line-height: 1.9;
`;

const Label = styled.div`
    font-size: 14px; 
    color: #2d8c3c; 
    margin: 20px 0 8px;
    font-weight: bold;
`;

const TextBox = styled.div`
`;

const OverViewRegion = styled.div`
`;

const AppBatchRegion = styled.div`
`;

const StepRegion = styled.div`
`;

const StepNum = styled.span`
    display: inline-block;
    background: #2d8c3c;
    color: #fff;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    text-align: center;
    line-height: 22px;
    font-size: 12px;
    font-weight: 700;
    margin-right: 8px;
`;
const StepBox = styled.div`
    background: #f0f7f1;
    border-radius: 8px;
    padding: 14px;
    margin: 8px 0;
`;

const QaRegion = styled.div`
`;

const QaBox = styled.div`
    margin-top:12px;
`;

const QaTitle = styled.div`
    font-weight: bold;
`;


const InquiryRegion = styled.div`
`;